import './instagram_dm_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramReelShareDMContent extends Monitoring.Models.SocialContents.InstagramDMContent

  getMainText: ->
    @data.content?.reel_share?.text
